import "./index.scss";

import React from "react";
import { connect } from "react-redux";

@connect(store => {
    return {
        workstreams: store.workstreams
    };
})

class RemoveUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: null
        }
    }

    render() {
        const { workstreams, dispatch, projectId } = this.props;
        const raw = (workstreams.selected.members || []).filter(m => m.isSelected);
        const selected = raw.length > 0 ? raw[0] : {};
        const taskCountActive =  (selected.assigneeIn?.length + selected.reviewerIn?.length + selected.approverIn?.length) || 0;

        const handleViewReassign = () => {
            dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED_MEMBER", member: selected });

            $('#removeUser').modal('hide');
            $('#reassignTask').modal('show');
        }

        const handleRemove = () => {
            dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: {
                ...workstreams.selected, 
                members: workstreams.selected.members.map(m => {
                    if(m.id === selected.id) {
                        return {...m, isRemoved: true}
                    }

                    return m;
                })
            }});

            $('#removeUser').modal('hide');
        }

        return (
            <div class="modal fade confirm-modal bg-overlay" data-backdrop="static" data-keyboard="false" id="removeUser">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bb pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 brndnTxt-m mb0 mt5">Remove Member from this Workstream?</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a  class="text-right text-black" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body pt10 pb10">
                            {taskCountActive > 0 ? 
                                <p>This member currently has task/s assigned to them. Kindly reassign their task/s first.</p>
                            : 
                                <p>Do you wish to proceed?</p>
                            }
                            
                        </div>
                        <div class="modal-footer bt">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btnCancel ml0" data-dismiss="modal">Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    {taskCountActive > 0 && <button type="button" class="btn btnRemove" onClick={handleViewReassign}>Reassign Task/s</button>}
                                    {taskCountActive === 0 && <button type="button" class="btn btnRemove" onClick={handleRemove}>Remove Member</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RemoveUser;
